define('extensions/knockout/functions/log', ['knockout'], function (ko) {
    ko.subscribable.fn.log = function (title, mapper) {
        mapper = mapper || _.identity;

        return this.tap(function (v) { console.log(title, mapper(v)) });
    };
});